// Playbook theme: dark / light. Single class on <html> drives every Tailwind
// utility (the tokens in tailwind.config.js point at CSS vars that flip via
// :root.light). Same pattern + palette + reflow workaround as the CRM and the
// reporting dashboard so the agency reads consistent across the three apps.

import { writable } from "svelte/store";

const KEY = "lgp-playbook:theme";
type Theme = "dark" | "light";

function load(): Theme {
  if (typeof localStorage === "undefined") return "dark";
  return localStorage.getItem(KEY) === "light" ? "light" : "dark";
}

export const theme = writable<Theme>(load());

export function applyTheme(t: Theme) {
  if (typeof document === "undefined") return;
  try {
    localStorage.setItem(KEY, t);
  } catch {
    /* private mode / quota - ignore */
  }
  const html = document.documentElement;
  html.classList.toggle("light", t === "light");

  // Chromium CSS-var paint cache: <body> + cards backed by var(--bg-panel)
  // sometimes don't re-paint until the layout is forced. Targeting <body>
  // (rather than just <main>) catches the case where the body's background
  // is what stayed stuck. Hiding for one tick is invisible to the user.
  if (document.body) {
    const prev = document.body.style.display;
    document.body.style.display = "none";
    void document.body.offsetWidth;
    document.body.style.display = prev;
  }
}

theme.subscribe((t) => applyTheme(t));
